import { render, staticRenderFns } from "./BeCalledQualificationQuestion.vue?vue&type=template&id=626ae99e&scoped=true"
import script from "./BeCalledQualificationQuestion.vue?vue&type=script&lang=ts"
export * from "./BeCalledQualificationQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626ae99e",
  null
  
)

export default component.exports